import React from "react";
import {useTranslation} from "react-i18next";
import SpaceBetween from "@awsui/components-react/space-between";
import AllAnswersTable from "pages/standings/components/AllAnswersTable";
import Competition from "model/Competition";
import { useQuery } from "react-query";
import { Flashbar, Spinner } from "@awsui/components-react";
import getAnswers from "api/getAnswers";
import { useAuth } from "hooks/useAuth";
import AllAnswers from "model/AllAnswers";


interface AllAnswersComponentProps {
    competition: Competition;
}

const AllAnswersComponent: React.FC<AllAnswersComponentProps> = (props) => {

    const {t} = useTranslation(["common", "errors"]);
    const competition = props.competition;

    const [{ league, user }] = useAuth();

    // <LeagueRoute> wraps /standings in App.tsx, so league is always defined here.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const leagueForApi = league!;

    const {
        isLoading: answersIsLoading,
        data: answers,
        error: getAnswersError
    } = useQuery<AllAnswers, Error>(`getAnswers-${competition.code}`, () => getAnswers(competition, leagueForApi, user?.token));

    if (answersIsLoading) {
        return (
            <Spinner size="big" variant="normal" />
        );
    }

    if (getAnswersError) {
        return (
            <Flashbar
                items={[{
                    header: t("errors:answersLoad"),
                    type: "error",
                    content: t("common:errors.tryReload"),
                    dismissible: false,
                }]}
            />
        );
    }

    const renderedAnswerTables = answers?.answers.map(answer => {
        return (
            <AllAnswersTable
                key={answer.username || ""}
                username={answer.username || ""}
                questions={answers.questions}
                answers={answer.userAnswers}
                points={answer.points}
            />
        );
    });

    return (
        <SpaceBetween size="m" direction="horizontal">
            {renderedAnswerTables}
        </SpaceBetween>
    );
};

export default AllAnswersComponent;
